"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGiftAidEligible = void 0;
const isGiftAidEligible = (organization) => {
    return organization.hasConnectedSwiftaidAtUtc && organization.hmrcReferenceNumber;
};
exports.isGiftAidEligible = isGiftAidEligible;
